import React from "react";
import styles from "./Destinations8.module.css";

const fallbackImages = [
  "/assets/images/default-package.jpg",
  "/assets/images/default-package2.png",
  "/assets/images/default-package3.png",
  "/assets/images/default-package4.png",
  "/assets/images/default-package5.png",
  "/assets/images/default-package6.jpg"
];

const Destinations8 = ({ destinations = [] }) => {
  if (!destinations || destinations.length === 0) return null;

  // Duplicate array for seamless infinite scrolling
  const scrollItems = [...destinations, ...destinations];

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            Dream <span>Getaways</span>
          </h2>
          <p className={styles.lead}>
            Soft transitions into breathtaking views
          </p>
        </div>

        <div className={styles.trackWrapper}>
          <div className={styles.track}>
            {scrollItems.map((dest, index) => {

              const fallbackImage =
                fallbackImages[index % fallbackImages.length];

              const imageUrl =
                dest?.image && dest.image.trim() !== ""
                  ? dest.image
                  : fallbackImage;

              return (
                <div key={index} className={styles.card}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={imageUrl}
                      alt={dest?.name || "Destination"}
                      className={styles.image}
                      onError={(e) => {
                        e.target.src = fallbackImage;
                      }}
                    />

                    <div className={styles.floatingPill}>
                      <span className={styles.pillText}>
                        {dest?.name || "Explore Destination"}
                      </span>

                      <div className={styles.circleArrow}>
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                        >
                          <path d="M7 17L17 7M17 7H7M17 7V17" />
                        </svg>
                      </div>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Destinations8;